var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"schema_wrapper"},[_c('h4',[_vm._v("产品优势")]),_c('div',{staticClass:"content"},[_c('el-image',{staticStyle:{"width":"100%","height":"350px"},attrs:{"src":require('../assets/imgs/advantage.png'),"fit":'fit'}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }